export default {
  input: 'input-with-label-input',
  labelledElement: 'input-with-label-labelled-element',
  errorMessage: 'input-with-label-error-message',
};
